import { useWindowSize } from '../useWindowSize/useWindowSize.js';

const useBreakpointsMatching = () => {
    const windowSize = useWindowSize();
    const { innerWidth } = windowSize;
    return {
        toString: function () {
            return deviceMatching(innerWidth);
        },
        match: function (...breakpoints) {
            return breakpoints.includes(this.toString());
        },
    };
};
const deviceMatching = (width) => {
    if (width < 375) {
        return 'SMARTPHONE';
    }
    if (width < 544) {
        return 'PHABLET';
    }
    if (width < 768) {
        return 'TABLET';
    }
    if (width < 1024) {
        return 'LAPTOP';
    }
    return 'DESKTOP';
};

export { useBreakpointsMatching };
//# sourceMappingURL=useBreakpointsMatching.js.map
